import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
//import actions from './actions';
//import getters from './getters';

Vue.use(Vuex);

const state = {
  templateConfig: {
    theme: '',
    bannerImage: '',
    bannerColor: '',
    fontColor: '',
    btnColor: '',
    btnTextColor: '',
    logo: '',
    backgroundColor: '',
    backgroundImage: '',
    isButtonRounded: '',
    language: '',
    isRtl: '',
  },

  merchantConfig: {
    configs: [],
    fields: [],
    merchantId: '',
    successMsgs: {},
    texts: [],
  },

  OTPDetails: {},

  UnsubscribeFlowDetails: {},

  SubscribeFlowDetails: {
    subscriptionProductDetails: {},
    merchantOperatorDisclaimer: {},
    selectedOperator: {
      disclaimerParams: {},
    },
  },
};

export default new Vuex.Store({
  state,
  mutations,
  //actions,
  //getters,
});
